import { useZoom } from '@/hooks/useZoom';
import { FC, useRef } from 'react';

type SlideProp = {
    pickingComponentType: string | null;
    onCreateComponent: (pickingComponentType: string, position: { x: number; y: number }) => void;
};

export const SlideComponentCreationLayer: FC<SlideProp> = ({ pickingComponentType, onCreateComponent }) => {
    const ref = useRef(null);
    const scale = useZoom(ref, undefined);

    return (
        <>
            <div
                ref={ref}
                style={{
                    height: '100%',
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    cursor: 'crosshair',
                }}
                onClick={async (e) => {
                    if (!pickingComponentType) {
                        return;
                    }

                    // Get coordinates relative to the clicked element
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;

                    onCreateComponent(pickingComponentType, { x: x / scale, y: y / scale });
                }}
                aria-label={'canvas-creation-layer'}
            />
        </>
    );
};
